import { defineComponent as r, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as h } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "6529566a-4473-4550-b2c0-e93289b27a9b" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#6529566a-4473-4550-b2c0-e93289b27a9b)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M144.8 0h222.4l32 260-32 252H144.8l-32.1-256z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m256.1 167 22.1 68h71.5L292 277l22 68-57.8-42-57.9 42 22.1-68-57.8-42H234z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 0h144.8v512H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M367.2 0H512v512H367.2z"
}, null, -1), w = { fill: "none" }, b = ["r"], B = /* @__PURE__ */ r({
  __name: "cm",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, z) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", p, d(t.flagName), 1)) : _("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=cm-a92f33e6.js.map
